export default __webpack_public_path__ + "static/media/3.2ee40695.png";